var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#338FCE",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.0034H18.0399V33.4967V33.9967H18.5399H26.925C29.7018 33.9967 31.9986 31.7925 31.9986 29.0636V16.5034V16.0034H31.4986H19.0399H18.5399H18V17.0034ZM19.0399 32.9967V17.0034H30.9986V29.0636C30.9986 31.2111 29.1792 32.9967 26.925 32.9967H19.0399ZM21.9209 22.1753H27.9307V21.1753H21.9209V22.1753ZM27.9307 25.1306H21.9209V24.1306H27.9307V25.1306ZM21.9209 28.086H26.4283V27.086H21.9209V28.086Z",
    fill: "#338FCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCover);
export default __webpack_public_path__ + "static/media/documentCover.13e53a68c00cef6446a8c8aa752d6fd4.svg";
export { ForwardRef as ReactComponent };